<template>
  <section class="px-4 py-12 md:py-16 bg-neutral-700">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center">
      <h2>{{ t('landing.spots.title') }}</h2>
      <p class="text-lg md:text-xl text-neutral-200 max-w-2xl">{{ t('landing.spots.body') }}</p>

      <ul class="text-neutral-200 max-w-2xl text-left">
        <li v-for="point in POINTS" :key="point">{{ t(`landing.spots.${point}`) }}</li>
      </ul>

      <!-- A rebuild of the spot list in the panel rather than a screenshot: it
           stays sharp, follows the theme and never goes stale. -->
      <div class="w-full mt-6 rounded-2xl bg-neutral-800 p-4 md:p-6 text-left flex flex-col gap-3">
        <span class="text-xs text-neutral-400 uppercase tracking-wide">{{ t('landing.spots.mockTitle') }}</span>
        <div
          v-for="spot in MOCK_SPOTS"
          :key="spot.key"
          class="rounded-lg border border-neutral-700 p-4 flex flex-row items-center justify-between gap-4"
        >
          <div class="min-w-0">
            <div class="font-extrabold truncate">{{ t(`landing.spots.mock.${spot.key}.name`) }}</div>
            <div class="text-sm text-neutral-400">{{ t(`landing.spots.mock.${spot.key}.schedule`) }}</div>
          </div>
          <span
            class="px-2 py-1 rounded text-sm whitespace-nowrap"
            :class="spot.active ? 'bg-primary text-black' : 'border border-primary text-primary'"
          >
            {{ t(spot.active ? 'campaignStatus.active' : 'campaignStatus.scheduled') }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const POINTS = ['length', 'schedule', 'period', 'rotation', 'empty'] as const
const MOCK_SPOTS = [
  { key: 'lunch', active: true },
  { key: 'weekend', active: true },
  { key: 'sale', active: false },
] as const
</script>
